import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { TurnoDBService } from '../database/turno-db.service';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class TurnoService extends BaseService{
    override classname: string = 'TurnoService';
    public override route: string = 'turno';
    public override database = Capacitor.isNativePlatform() ? new TurnoDBService() : new TurnoDBService();
}
